export const hoverLinePlugin = {
    id: 'hoverLine',
    afterDraw(chart, args, options) {
        const { ctx, scales, chartArea } = chart;
        const hoverPixelY = chart.options.plugins.hoverLine?.hoverPixelY;

        if (hoverPixelY === null || hoverPixelY === undefined) return;

        const yScale = scales['y'];
        const yValue = yScale.getValueForPixel(hoverPixelY);

        ctx.save();
        ctx.beginPath();
        ctx.moveTo(chartArea.left, hoverPixelY);
        ctx.lineTo(chartArea.right, hoverPixelY);
        ctx.lineWidth = 1;
        ctx.strokeStyle = 'rgba(0, 0, 0, 0.6)';
        ctx.setLineDash([5, 5]);
        ctx.stroke();
        ctx.setLineDash([]);
        ctx.restore();

        const boxWidth = 40;
        const boxHeight = 20;
        const padding = 5;
        const leftOffset = chartArea.left - boxWidth - padding;

        ctx.fillStyle = '#000';
        ctx.fillRect(leftOffset, hoverPixelY - boxHeight / 2, boxWidth, boxHeight);
        ctx.fillStyle = '#fff';
        ctx.font = 'bold 12px sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(yValue.toFixed(1), leftOffset + boxWidth / 2, hoverPixelY);
    },
};
